import { getPublicConfig } from "@/helpers/getPublicConfig";

export const getVercelEnv = () => {
  const config = getPublicConfig();
  return config.env.vercelEnv;
};
